import React from 'react';
import CardBaseOtherServices from './CardBaseOtherServices';
import { useLang } from '../i18n';
import './Cards.css';

function OtherServices() {
  const { t } = useLang();
  return (
    <div>
      <div className='cards__next'>
        <h1>{t('info.servicesTitle')}</h1>
        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>
              <CardBaseOtherServices 
                label={t('info.stringing')}
                text={t('info.stringingAvail')}
                price1={t('info.stringingOnly')}
                price2={t('info.stringingNew')}
              />
              <CardBaseOtherServices 
                label={t('info.meals')}
                text={t('info.mealsDesc')}
                price1={t('info.lunch')}
                price2={t('info.dinner')}
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtherServices;